<script setup lang="ts">
interface Aggregate {
  ratingValue: number
  reviewCount: number
}
const props = defineProps<{
  data?: { aggregate?: Aggregate | null, profileUrl?: string | null } | null
  reviewsTargetId: string
}>()

const aggregate = computed(() => props.data?.aggregate ?? null)
const profileUrl = computed(() =>
  props.data?.profileUrl || 'https://www.trustpilot.com/review/180medical.com')

const reviewsLabel = computed(() => aggregate.value
  ? `Read the ${aggregate.value.reviewCount.toLocaleString()} product reviews on this page`
  : '')

function scrollToReviews() {
  document.getElementById(props.reviewsTargetId)?.scrollIntoView({ behavior: 'smooth' })
}
</script>

<template>
  <div
    v-if="aggregate"
    class="inline-flex flex-wrap items-center gap-x-3 gap-y-1"
    data-testid="trustpilot-product-summary"
  >
    <button
      type="button"
      class="inline-flex cursor-pointer flex-wrap items-center gap-x-3 gap-y-1 border-0 bg-transparent p-0 text-left no-underline hover:underline"
      :aria-label="reviewsLabel"
      data-testid="trustpilot-product-summary-reviews"
      @click="scrollToReviews"
    >
      <TrustpilotStars
        :rating="aggregate.ratingValue"
        size="sm"
      />
      <span class="text-med-deep-navy">
        <strong>{{ aggregate.ratingValue.toFixed(1) }}</strong> / 5
      </span>
      <span class="text-sm text-med-dark-gray">
        {{ aggregate.reviewCount.toLocaleString() }} product reviews
      </span>
    </button>
    <a
      class="no-underline"
      :href="profileUrl"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="180 Medical on Trustpilot"
      data-testid="trustpilot-product-summary-profile"
    >
      <TrustpilotLogo size="sm" />
    </a>
  </div>
</template>
